import { Fragment, useEffect,useState } from 'react'
import { Row } from 'react-bootstrap'
import ProductCard from '../components/ProductCard'


export default function Products() {
  
  const [products, setProducts] = useState([]);



    // console.log(coursesData);
    // console.log(coursesData[0]);

   useEffect(() => {
      fetch(`${process.env.REACT_APP_API_URL}product/`)
      .then(res => res.json())
      .then(data => {
           
          console.log(data);
          setProducts(data.map(product => {

            return (
              <ProductCard key={product._id} productProp={product} />
            )
          }))

      })
   }, [])


  

    return (
        <Fragment>
          <h1 className='text-center mt-3'>Products</h1>

          <Row className="d-flex m-3">
            {products}
          </Row>
        </Fragment>
  )
}

